import React, { useState } from 'react';
import { connect } from 'react-redux';

import MobileHeader from './Mobile';

import { resetLoginData, setLoginAction } from '../../actions/login';
import { setRuntimeVariable, showModal } from '../../actions/runtime';
import { analyticsTrackEvent } from '../../core/analytics';
import { getDevice, getOs, isMobile } from '../../core/util/device';
import { HEADER_DIRECTORY_LINKS_CLICK_LOGIN_SIGNUP } from '../../core/analytics/events';
import { LOGIN_ACTION_LOGIN, LOGIN_ACTION_SIGN_UP } from '../../constants/index';
import { LOGIN_SIGN_UP_MODAL } from '../LoginSignUpModal';
import { apiPostDispatchable } from '../../core/dapi';
import { getAppInteractionsUrl } from '../../core/dapi/appInteractions';
import { noOp } from '../../actions';
import { accountTrackInteraction } from '../../actions/account';
import { getTrackingPageEventName } from '~/components/ProviderGroup/Provider/util';

import { StickyWrap } from './styles';
import DesktopHeader from './Desktop';

type HeaderDirectoryLinksProps = {
  openLogInModal: () => void;
};
const HeaderDirectoryLinks = ({ openLogInModal }: HeaderDirectoryLinksProps) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [hasScrolledMobile, setHasScrolledMobile] = useState(false);
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <StickyWrap mobileLinksOpen={mobileMenuOpen} onScroll={() => setHasScrolledMobile(true)}>
      <DesktopHeader openLogInModal={openLogInModal} />
      <MobileHeader
        hasScrolled={hasScrolledMobile}
        mobileMenuOpen={mobileMenuOpen}
        openLogInModal={openLogInModal}
        toggleMobileMenu={toggleMobileMenu}
      />
    </StickyWrap>
  );
};

const mapStateToProps = (state: any, ownProps: any) => {
  const bookingProfile = state.newBooking?.booking?.userProfile?.user_profile_id
    ? state.newBooking.booking.userProfile
    : null;
  const defaultProfile = state.account?.summary?.user_profiles?.[0];

  return {
    viewport: state.runtime.viewport,
    isSavingAppInteraction: state.runtime.isSavingAppInteraction,
    login: state.login,
    accountSummary: state.account.summary,
    userProfile: ownProps.userProfile || bookingProfile || defaultProfile,
    userAgent: state.sessionTrackingProperties.userAgent,
  };
};

const mapDispatchToProps = (dispatch: any, ownProps: any) => ({
  showAddToHomeScreenPopUp: () =>
    dispatch(setRuntimeVariable({ name: 'showAddToHomeScreenPopUp', value: true })),

  resetLogin: () => {
    if (ownProps.resetLogin) ownProps.resetLogin();
    dispatch(resetLoginData());
  },

  showModal: (modalId: string) => dispatch(showModal(modalId)),

  openLogInModal: () => {
    analyticsTrackEvent(HEADER_DIRECTORY_LINKS_CLICK_LOGIN_SIGNUP, {
      isMobile: isMobile(),
      page: getTrackingPageEventName(),
    });
    dispatch(setLoginAction(LOGIN_ACTION_LOGIN));
    dispatch(showModal(LOGIN_SIGN_UP_MODAL));
  },

  openSignUpModal: () => {
    analyticsTrackEvent(HEADER_DIRECTORY_LINKS_CLICK_LOGIN_SIGNUP, { isMobile: isMobile() });
    dispatch(setLoginAction(LOGIN_ACTION_SIGN_UP));
    dispatch(showModal(LOGIN_SIGN_UP_MODAL));
  },

  trackAppInteraction: (accountId: any, userProfileId: any, moduleType: any, action: any) => {
    const params = {
      account_id: accountId,
      user_profile_id: userProfileId,
      module_type: moduleType,
      action,
      source_os: getOs().userOS,
      source_device: getDevice(),
    };
    dispatch(setRuntimeVariable({ name: 'isSavingAppInteraction', value: true }));
    const onSuccess = (response: any) => {
      dispatch(accountTrackInteraction(response));
      return setRuntimeVariable({ name: 'isSavingAppInteraction', value: false });
    };
    dispatch(apiPostDispatchable(getAppInteractionsUrl(), params, onSuccess, noOp));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderDirectoryLinks);
